import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/elements/button';
import { Search, Add, Edit, Trash, File } from '../../assets/icons';

const AdminCourses = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filters, setFilters] = useState({
        category: 'all',
        status: 'all',
        level: 'all'
    });

    const [courses] = useState([
        {
            id: 'CRS001',
            title: 'Fundamentals of Aquaculture',
            category: 'Basic Training',
            instructor: 'Dr. James Wilson',
            duration: '6 weeks',
            enrolled: 156,
            rating: 4.8,
            status: 'active',
            level: 'beginner',
            thumbnail: '/courses/aquaculture-basics.jpg',
            lastUpdated: '2024-03-15',
            modules: 12,
            price: 25000
        }
    ]);

    const handleDeleteCourse = (_courseId) => {
        // Handle course deletion
    };

    return (
        <div className="admin-courses">
            <div className="page-header">
                <div className="header-content">
                    <h1>Course Management</h1>
                    <p>Manage and monitor educational content</p>
                </div>
                <Link to="/admin/courses/new">
                    <Button
                        icon={<img src={Add} alt="" />}
                        text="Create Course"
                        variant="primary"
                    />
                </Link>
            </div>

            <div className="filters-section">
                <div className="search-bar">
                    <img src={Search} alt="" />
                    <input
                        type="text"
                        placeholder="Search courses..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="filters">
                    <select
                        value={filters.category}
                        onChange={(e) => setFilters({...filters, category: e.target.value})}
                    >
                        <option value="all">All Categories</option>
                        <option value="basic">Basic Training</option>
                        <option value="advanced">Advanced Techniques</option>
                        <option value="business">Business Management</option>
                        <option value="health">Fish Health</option>
                    </select>

                    <select
                        value={filters.status}
                        onChange={(e) => setFilters({...filters, status: e.target.value})}
                    >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="draft">Draft</option>
                        <option value="archived">Archived</option>
                    </select>

                    <select
                        value={filters.level}
                        onChange={(e) => setFilters({...filters, level: e.target.value})}
                    >
                        <option value="all">All Levels</option>
                        <option value="beginner">Beginner</option>
                        <option value="intermediate">Intermediate</option>
                        <option value="advanced">Advanced</option>
                    </select>
                </div>
            </div>

            <div className="courses-grid">
                {courses.map(course => (
                    <div key={course.id} className="course-card">
                        <div className="course-thumbnail">
                            <img src={course.thumbnail} alt={course.title} />
                            <span className={`status ${course.status}`}>
                                {course.status}
                            </span>
                        </div>

                        <div className="course-content">
                            <h3>{course.title}</h3>
                            
                            <div className="course-meta">
                                <span className="category">{course.category}</span>
                                <span className="level">{course.level}</span>
                            </div>

                            <div className="instructor">
                                <span>Instructor:</span>
                                {course.instructor}
                            </div>

                            <div className="stats-grid">
                                <div className="stat">
                                    <label>Duration</label>
                                    <span>{course.duration}</span>
                                </div>
                                <div className="stat">
                                    <label>Modules</label>
                                    <span>{course.modules}</span>
                                </div>
                                <div className="stat">
                                    <label>Enrolled</label>
                                    <span>{course.enrolled}</span>
                                </div>
                                <div className="stat">
                                    <label>Rating</label>
                                    <span>★ {course.rating}</span>
                                </div>
                            </div>

                            <div className="course-footer">
                                <span className="price">₦{course.price.toLocaleString()}</span>
                                <span className="updated">Updated: {course.lastUpdated}</span>
                            </div>
                        </div>

                        <div className="card-actions">
                            <Link to={`/admin/courses/${course.id}`}>
                                <Button
                                    icon={<img src={File} alt="" />}
                                    text="View"
                                    variant="outline"
                                />
                            </Link>
                            <Link to={`/admin/courses/${course.id}/edit`}>
                                <Button
                                    icon={<img src={Edit} alt="" />}
                                    text="Edit"
                                    variant="primary"
                                />
                            </Link>
                            <Button
                                icon={<img src={Trash} alt="" />}
                                text="Delete"
                                variant="error"
                                onClick={() => handleDeleteCourse(course.id)}
                            />
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminCourses;